import { Box, Text, toast, useToast } from '@chakra-ui/react';
import * as RadioGroup from '@radix-ui/react-radio-group';
import { format, getTime, setHours, setMinutes } from 'date-fns';
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import { BsArrowDownCircle } from 'react-icons/bs';
import { CiCalendar } from 'react-icons/ci';

import { DatePickerExport } from '../../../../../components/datepicker/DatePickerExport';
import { apiSensedia } from '../../../../../services/api-sensedia';
import StatusDetailsConcluido from './StatusDetailsConcluido';
import StatusDetailsNegociacao from './StatusDetailsNegociacao';
type DialogProps = {
  lead?: any;
  setLead?: Dispatch<SetStateAction<any>>;
  status?: string;
  dragResult?: any;
  onOpenModal?: () => void;
  onCloseModal?: () => void;
  getLeads?: (status: string, lead: string, changes: any) => void;
  isMobile?: boolean;
  rollbackLead?: (result: any) => void;
  updateLead?: (
    destiny_droppable: string,
    status: string,
    lead: string,
    changes: any
  ) => void;
};
function ModalChangeStatus({
  lead,
  setLead,
  getLeads,
  isMobile,
  status,
  onOpenModal,
  dragResult,
  onCloseModal,
  rollbackLead,
  updateLead
}: DialogProps) {
  const [anotacoes, setAnotacoes] = useState('');
  const [percepcao, setPercepcao] = useState('');
  const [actualStatus, setActualStatus] = useState('');
  const [loadingSave, setLoadingSave] = useState(false);
  const [tentativas, setTentativas] = useState('');
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [emNegociacaoInfo, setEmNegociacaoInfo] = useState(null);
  const toast = useToast();
  const mobileRef = useRef(window.innerWidth);
  const [conclusionInfo, setConclusionInfo] = useState({
    query: {
      plan_saude: null,
      plan_odonto: null,
      plan_vida: null,
      products: null,
      type: null,
      sem_sucesso: null
    }
  });
  const [time, setTime] = useState('00:00');

  const formatType = (type) => {
    switch (type) {
      case 'venda-realizada':
        return true;
      case 'venda-nao-realizada':
        return false;
      default:
        return null;
    }
  };

  const searchStatus = (status: string) => {
    switch (status) {
      case 'Novas Oportunidades':
        return 'Novas Oportunidades';
      case 'NovoContato':
        return 'Agendado';
      case 'EmNegociacao':
        return 'Em negociação';
      case 'Concluido':
        return 'Concluído';
      default:
        return '-';
    }
  };

  const formatDate = (date) => {
    const splitTime = time.split(':');
    const formatedHours = setHours(date, +splitTime[0]);
    const formatedMinutes = setMinutes(formatedHours, +splitTime[1]);
    const toTimestamp = getTime(formatedMinutes);

    return toTimestamp;
  };

  const formatBody = () => {
    let formatQuery: any = {
      status: status ? status : null
    };

    if (status === 'Concluido') {
      const validatePlans = {
        plan_saude: conclusionInfo.query.plan_saude
          ? conclusionInfo.query.plan_saude
          : null,
        plan_odonto: conclusionInfo.query.plan_odonto
          ? conclusionInfo.query.plan_odonto
          : null,

        plan_vida: conclusionInfo.query.plan_vida
          ? conclusionInfo.query.plan_vida
          : null
      };

      for (const filter in validatePlans) {
        if (validatePlans[filter] === null || validatePlans[filter] === '') {
          delete validatePlans[filter];
        }
      }

      formatQuery = {
        ...formatQuery,
        ...formatQuery.query,
        abordagem: formatType(conclusionInfo.query.type),
        abordagem_n2: conclusionInfo.query.sem_sucesso
          ? conclusionInfo.query.sem_sucesso
          : null,
        produtos: conclusionInfo.query.products
          ? conclusionInfo.query.products
          : null,
        planos:
          Object.keys(validatePlans).length > 0
            ? Object.values(validatePlans)
            : null
      };
    } else {
      formatQuery = {
        ...formatQuery,
        tentativas: tentativas ? tentativas : null,
        abordagem_n2: emNegociacaoInfo ? emNegociacaoInfo : null,
        data_agendamento: startDate ? formatDate(startDate) : null,
        percepcao: percepcao ? percepcao : null,
        anotacoes: anotacoes ? anotacoes : null
      };
    }

    for (const filter in formatQuery) {
      if (formatQuery[filter] === null || formatQuery[filter] === '') {
        delete formatQuery[filter];
      }
    }
    return formatQuery;
  };

  const validateCanSave = () => {
    if (status === 'NovoContato' && startDate !== null && tentativas !== '') {
      return true;
    }

    if (status === 'EmNegociacao' && emNegociacaoInfo !== null) {
      return true;
    }

    if (status === 'Concluido') {
      const productsPlan = {
        Saúde: 'plan_saude',
        Odonto: 'plan_odonto',
        Vida: 'plan_vida'
      };
      let validatePlan = true;

      const validProductsPlan = conclusionInfo.query.products?.filter(
        (product) => {
          return (
            product === 'Saúde' || product === 'Odonto' || product === 'Vida'
          );
        }
      );
      validProductsPlan?.forEach((product) => {
        const planKey = productsPlan[product];
        const productPlan = conclusionInfo.query[planKey];

        if (
          productPlan === null ||
          productPlan === undefined ||
          productPlan === ''
        ) {
          validatePlan = false;
        }
      });

      if (
        conclusionInfo.query.type === 'venda-realizada' &&
        validatePlan &&
        conclusionInfo.query.products?.length > 0
      )
        return true;
      if (
        conclusionInfo.query.type === 'venda-nao-realizada' &&
        conclusionInfo.query.sem_sucesso !== null
      )
        return true;
    }
    return false;
  };

  const saveLeadStatus = async () => {
    const validateInputs = validateCanSave();
    if (validateInputs === false) return;
    try {
      setLoadingSave(true);
      const body = formatBody();
      await apiSensedia.put(
        `oportunidades-sulamerica/painel-leads/leads/` + lead.ID_LEAD__c,
        { ...body }
      );
      if (isMobile !== true) {
        const { source, destination } = dragResult;
        updateLead(destination.droppableId, status, lead, body);
      }
      isMobile === true && getLeads(lead, status, body);
      onCloseModal();
      toast({
        position: 'top',
        description: 'As alterações foram salvas com sucesso.',
        status: 'success',
        duration: 4000,
        isClosable: true
      });
      setLoadingSave(false);
    } catch (e: any) {
      const errorObj = e?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || e?.response?.data?.statusCode) && (
                <>{errorObj.status ?? e.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (e?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(e?.response?.data?.message || errorObj?.message) && (
                <>{e.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });
      setLoadingSave(false);
      console.log(e);
    }
  };

  return (
    <>
      <div className="tw-bg-[#5A5A5A] tw-w-[100%] tw-rounded-t-md tw-p-4 tw-z-30">
        <p className="tw-text-white tw-font-bold">
          Status do lead: {searchStatus(status || '')}
        </p>
        <p className="tw-text-white">
          Cliente:{' '}
          <span className="tw-text-white tw-font-bold">
            {lead?.NOME__c || ''}
          </span>
        </p>
      </div>
      {status === 'NovoContato' && (
        <div className="tw-flex tw-justify-start tw-items-start tw-flex-col tw-rounded-lg tw-p-4 tw-gap-4  ">
          <div>
            <p className="tw-text-start tw-font-bold">
              Tentativas de agendamento
              <a className="tw-text-red-500 tw-font-bold"> *</a>
            </p>
          </div>
          <select
            onChange={(e) => {
              setTentativas(e.target.value);
            }}
            value={tentativas || ''}
            className="tw-p-2 tw-rounded-full tw-w-[10rem] tw-border-[#001E64] tw-border-solid tw-border-[1px]"
          >
            <option value={''}>Selecione</option>
            <option value={'1'}>1ª Tentativa</option>
            <option value={'2'}>2ª Tentativa</option>
            <option value={'3'}>3ª Tentativa</option>
            <option value={'4'}>4ª Tentativa</option>
            <option value={'Outras'}>Outras</option>
          </select>
          <div>
            <p className="tw-text-start tw-font-bold">
              Agendar contato com lead
              <a className="tw-text-red-500 tw-font-bold"> *</a>
            </p>
          </div>
          <div className="sm:tw-block tw-w-[49%]  tw-rounded-md ">
            <div className="tw-flex tw-gap-4 tw-items-center tw-w-[100%]">
              <div className="tw-flex tw-relative tw-w-[100%] tw-justify-between tw-items-end tw-gap-4">
                <div>
                  <button
                    onClick={() => {
                      setOpenDatePicker(!openDatePicker);
                    }}
                    className="tw-flex tw-gap-1 tw-items-center tw-px-3 tw-bg-white tw-text-[#001E64] tw-p-2 tw-rounded-full tw-justify-between tw-w-[10rem] tw-border-[0.1rem] tw-border-[#001E64]"
                  >
                    <CiCalendar size={'1.2rem'} />

                    <span>
                      {startDate !== null
                        ? format(new Date(startDate), 'dd/MM/yyyy')
                        : '--/--/--'}
                    </span>
                  </button>
                  <DatePickerExport
                    time={time}
                    setTime={setTime}
                    uniqueDate={true}
                    isOpen={openDatePicker}
                    setStartDate={setStartDate}
                    setIsOpen={setOpenDatePicker}
                    isMobile={mobileRef.current < 720}
                  />
                </div>
              </div>

              <input
                className="tw-flex tw-gap-1 tw-items-center tw-px-3 tw-bg-white tw-text-[#001E64] tw-p-2 tw-rounded-full tw-justify-between tw-w-[10rem] tw-border-[0.1rem] tw-border-[#001E64]"
                value={time}
                onChange={(e) => {
                  setTime(e.target.value);
                }}
                type={'time'}
              />
            </div>
          </div>
        </div>
      )}
      {status === 'EmNegociacao' && (
        <div className="tw-p-4">
          <StatusDetailsNegociacao
            info={emNegociacaoInfo}
            setInfo={setEmNegociacaoInfo}
          />
        </div>
      )}
      {status === 'Concluido' && (
        <div className="tw-p-4 tw-w-[100%] ">
          <span className="tw-font-bold">Status de venda</span>
          <StatusDetailsConcluido
            info={conclusionInfo}
            setInfo={setConclusionInfo}
            isModal={true}
          />
        </div>
      )}
      {actualStatus !== 'Concluido' && (
        <div className="tw-flex tw-justify-start tw-items-start tw-flex-col tw-rounded-lg tw-p-4 tw-gap-4">
          <p className="tw-text-start tw-font-bold">
            Percepção do contato com lead
            {actualStatus === 'NovoContato' && <span>Obrigatorio</span>}
          </p>

          <RadioGroup.Root
            className="tw-flex tw-gap-6"
            defaultValue=""
            value={percepcao}
          >
            <div className="tw-flex tw-gap-2 tw-items-center">
              <RadioGroup.Item
                className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                value="Quente"
                onClick={(e) => {
                  setPercepcao('Quente');
                }}
                id="r2"
              >
                <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
              </RadioGroup.Item>
              <label className="Label" htmlFor="r1">
                Quente
              </label>
            </div>
            <div className="tw-flex tw-gap-2 tw-items-center">
              <RadioGroup.Item
                className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                value="Morno"
                onClick={(e) => {
                  setPercepcao('Morno');
                }}
                id="r2"
              >
                <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
              </RadioGroup.Item>
              <label className="Label" htmlFor="r1">
                Morno
              </label>
            </div>
            <div className="tw-flex tw-gap-2 tw-items-center">
              <RadioGroup.Item
                className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                value="Frio"
                onClick={(e) => {
                  setPercepcao('Frio');
                }}
                id="r2"
              >
                <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
              </RadioGroup.Item>
              <label className="Label" htmlFor="r1">
                Frio
              </label>
            </div>
            <div className="tw-flex tw-gap-2 tw-items-center">
              <RadioGroup.Item
                className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                value="Não tem interesse"
                onClick={(e) => {
                  setPercepcao('Não tem interesse');
                }}
                id="r2"
              >
                <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
              </RadioGroup.Item>
              <label className="Label" htmlFor="r1">
                Não tem interesse
              </label>
            </div>
          </RadioGroup.Root>
          <textarea
            maxLength={500}
            className="tw-border-[#D2D2D2] tw-px-2 tw-rounded-lg tw-border-solid tw-border-[1px] tw-min-h-[6rem] tw-resize-none tw-bg-white tw-w-[100%]"
            value={anotacoes || ''}
            onChange={(e) => {
              setAnotacoes(e.target.value);
            }}
            placeholder="Anotações"
          />
          <p className="tw-text-right tw-w-full tw-text-[0.8rem]">
            {anotacoes?.length || 0}
            /500
          </p>
          <div className="tw-flex tw-justify-end tw-gap-2 tw-w-full tw-mt-4">
            <button
              className=" tw-inline-flex tw-text-[#FF5000] tw-justify-center tw-h-[2.5rem] tw-bg-white tw-px-8 tw-py-2 tw-text-sm tw-font-semibold tw-border-[#FA6B25] tw-rounded-full tw-border-[0.1rem] sm:tw-w-auto "
              onClick={() => {
                isMobile === false && rollbackLead(dragResult);
                onCloseModal();
              }}
            >
              Cancelar
            </button>
            {loadingSave === false ? (
              <button
                type="button"
                onClick={() => {
                  saveLeadStatus();
                }}
                className={
                  validateCanSave()
                    ? 'tw-inline-flex tw-w-[8rem] tw-justify-center tw-rounded-full tw-bg-[#FA6B25] tw-px-8 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-border-[0.1rem] tw-border-[#FA6B25]'
                    : 'tw-inline-flex tw-w-[8rem] tw-justify-center tw-rounded-full tw-bg-[#8c8c8c] tw-px-8 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-border-[0.1rem] tw-border-[#8c8c8c]'
                }
              >
                Salvar
              </button>
            ) : (
              <button
                disabled
                className="tw-bg-[#FF5000] tw-flex tw-items-center tw-justify-center  tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[10rem] tw-h-[2.5rem] tw-rounded-3xl"
              >
                <svg
                  className="tw-animate-spin tw-h-5 tw-w-5 tw-mr-3 "
                  viewBox="0 0 24 24"
                >
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                    className="spinner_P7sC"
                    fill="white"
                  />
                </svg>
                Processando...
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ModalChangeStatus;
